/**
 * Locations/Ubications Page
 */

import { MapPin } from 'lucide-react'
import { CatalogPage } from './CatalogPage'
import { useTranslation } from '@/hooks/useTranslation'

export function LocationsPage() {
  const { t } = useTranslation()

  return (
    <CatalogPage
      icon={MapPin}
      config={{
        endpoint: 'ubications',
        basePath: '/locations',
        title: t('catalogs.locations'),
        newItemLabel: t('catalogs.newLocation'),
        noItemsLabel: t('catalogs.noLocations'),
        displayField: 'name',
        secondaryField: 'description',
        columns: [
          { key: 'code', header: t('articles.code') },
          { key: 'name', header: t('clients.name') },
          { key: 'description', header: t('articles.description') },
        ],
      }}
    />
  )
}
